import { formatWithTimezone } from "../formatters"
import { IDateTimeFormatter, IDateTimeFormatterBuilder } from "../types/IDateTimeFormatter"
import { DateValue } from "../types/DateValue"
import { i18nFunc } from "../../i18n/types"
import { UserSettings } from "@cirrus/common/UserSettings"
import { formatDate, formatRelative } from "@cirrus/common/src/_legacy"

export class AppFormatter implements IDateTimeFormatter {
  i18n: i18nFunc
  userSettings: UserSettings

  constructor(i18n: i18nFunc, userSettings: UserSettings) {
    this.i18n = i18n
    this.userSettings = userSettings
  }

  formatWithTimezone = formatWithTimezone

  userFriendly(date: DateValue, format: string = "short") {
    if (!date) return {
      dtFull: this.i18n("General:Never"),
      dtRelative: this.i18n("General:Never")
    }
    const dtFull = formatDate(date, format)
    const dtRelative = formatRelative(date)
    return { dtFull, dtRelative }
  }

  withRegionalSettings(date: DateValue) {
    return {
      dtFull: date.toString(),
      dtRelative: date.toString(),
    }
  }
}

export class AppFormatterBuilder implements IDateTimeFormatterBuilder {
  build(i18n, userSettings): IDateTimeFormatter {
    return new AppFormatter(i18n, userSettings)
  }
}